<template>
  <div class="teams-list">
    <ContentBlock paddings>
      <div v-if="!teams.length" class="teams-list__message">
        Команды отсутствуют
      </div>
      <ul v-else class="teams-list__list">
        <li v-for="(team, index) in teams" :key="index">
          <TeamRow :team="team" :index="getIndex(index)" />
        </li>
      </ul>
      <AppPaginator
        v-show="pages > 1"
        v-model="params.page"
        :page-count="pages"
        class="text-xs-center mt-4"
      />
    </ContentBlock>
  </div>
</template>

<script>
import TeamRow from "./TeamRow";
import service from "@/services/team";
import AppPaginator from "@/components/ui/pagination/";

export default {
  name: "TeamsList",

  components: {
    TeamRow,
    AppPaginator
  },

  props: {
    slug: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    teams: new Array(6),
    loading: true,
    pages: 1,
    pageSize: 40,
    params: {
      page: 1
    }
  }),

  computed: {
    allParams() {
      return Object.assign({ city_id: this.slug }, this.params);
    }
  },

  watch: {
    allParams: {
      immediate: true,
      handler: "getItems"
    }
  },

  methods: {
    async getItems() {
      this.loading = true;
      const { success, data, pagination } = await service.getTeams(
        this.allParams
      );
      if (success) {
        this.teams = data;
        this.pages = pagination.pageCount;
        let newPage = Math.min(
          this.params.page,
          pagination.pageCurrent,
          pagination.pageCount
        );
        if (newPage < 1) newPage = 1;
        this.params.page = newPage;
        this.pageSize = pagination.defaultPageSize;
      }
      this.loading = false;
    },

    getIndex(index) {
      let page = this.params.page - 1;
      if (page < 0) page = 0;
      return index + (this.params.page - 1) * this.pageSize + 1;
    }
  }
};
</script>

<style lang="scss">
.teams-list {
  padding-top: 20px;
  &__toolbar {
    margin-bottom: 25px;
  }
  &__list {
    @include nl();
    li {
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }

  &__message {
    color: colors(text-2);
    /* padding: 30px; */
    text-align: center;
    font-size: 20px;
    font-weight: fw(bold);
  }
}
</style>
